import type { GameEvent } from "@/types"

export const leithaniaEvents: Record<string, GameEvent> = {
    "dlg-lt-ebenholz": {
        id: "dlg-lt-ebenholz",
        type: "dialog",
        dialogues: [
            {
                speaker: "map.speaker.ebenholz",
                expression: "eyeclosed",
                side: "left",
                text: "map.dialog.ltEbenholz.d1",
            },
            {
                speaker: "map.speaker.ebenholz",
                expression: "normal",
                side: "left",
                text: "map.dialog.ltEbenholz.d2",
            },
            {
                speaker: "map.speaker.doctor",
                expression: "normal",
                side: "right",
                text: "map.dialog.ltEbenholz.d3",
            },
            {
                speaker: "map.speaker.ebenholz",
                expression: "eyeclosed",
                side: "left",
                text: "map.dialog.ltEbenholz.d4",
            },
            {
                speaker: "map.speaker.amiya",
                expression: "happy",
                side: "right",
                text: "map.dialog.ltEbenholz.d5",
            },
            {
                speaker: "map.speaker.ebenholz",
                expression: "normal",
                side: "left",
                text: "map.dialog.ltEbenholz.d6",
            },
            {
                speaker: "map.speaker.doctor",
                expression: "normal",
                side: "right",
                text: "map.dialog.ltEbenholz.d7",
            },
            {
                speaker: "map.speaker.ebenholz",
                expression: "normal",
                side: "left",
                text: "map.dialog.ltEbenholz.d8",
            },
            {
                speaker: "map.speaker.ebenholz",
                expression: "normal",
                side: "left",
                text: "map.dialog.ltEbenholz.d9",
            },
            {
                speaker: "map.speaker.ebenholz",
                expression: "eyeclosed",
                side: "left",
                text: "map.dialog.ltEbenholz.d10",
            },
        ],
        choices: [],
    },

    "dlg-lt-lessing": {
        id: "dlg-lt-lessing",
        type: "dialog",
        dialogues: [
            {
                speaker: "map.speaker.lessing",
                expression: "normal",
                side: "left",
                text: "map.dialog.ltLessing.d1",
            },
            {
                speaker: "map.speaker.doctor",
                expression: "normal",
                side: "right",
                text: "map.dialog.ltLessing.d2",
            },
            {
                speaker: "map.speaker.lessing",
                expression: "normal",
                side: "left",
                text: "map.dialog.ltLessing.d3",
            },
            {
                speaker: "map.speaker.doctor",
                expression: "thinking",
                side: "right",
                text: "map.dialog.ltLessing.d4",
            },
            {
                speaker: "map.speaker.lessing",
                expression: "normal",
                side: "left",
                text: "map.dialog.ltLessing.d5",
            },
            {
                speaker: "map.speaker.savage",
                expression: "happy",
                side: "right",
                text: "map.dialog.ltLessing.d6",
            },
            {
                speaker: "map.speaker.doctor",
                expression: "normal",
                side: "right",
                text: "map.dialog.ltLessing.d7",
            },
            {
                speaker: "map.speaker.savage",
                expression: "normal",
                side: "right",
                text: "map.dialog.ltLessing.d8",
            },
            {
                speaker: "map.speaker.doctor",
                expression: "normal",
                side: "right",
                text: "map.dialog.ltLessing.d9",
            },
            {
                speaker: "map.speaker.lessing",
                expression: "normal",
                side: "left",
                text: "map.dialog.ltLessing.d10",
            },
        ],
        choices: [],
    },

    "evt-lt-01": {
        id: "evt-lt-01",
        type: "event",
        description: "map.event.lt01.desc",
        dialogues: [],
        choices: [
            {
                id: "c1",
                text: "map.event.lt01.c1",
                resultText: "map.event.lt01.c1r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.amiya",
                        expression: "happy",
                        text: "map.event.lt01.c1d",
                    },
                ],
            },
            {
                id: "c2",
                text: "map.event.lt01.c2",
                resultText: "map.event.lt01.c2r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.savage",
                        expression: "normal",
                        text: "map.event.lt01.c2d",
                    },
                ],
            },
        ],
    },

    "evt-lt-02": {
        id: "evt-lt-02",
        type: "event",
        description: "map.event.lt02.desc",
        dialogues: [],
        choices: [
            {
                id: "c1",
                text: "map.event.lt02.c1",
                resultText: "map.event.lt02.c1r",
                nextDialogues: [],
            },
            {
                id: "c2",
                text: "map.event.lt02.c2",
                resultText: "map.event.lt02.c2r",
                nextDialogues: [],
            },
        ],
    },

    "evt-lt-03": {
        id: "evt-lt-03",
        type: "event",
        image: require("@/assets/imgs/gallery/CG/cg-leithania-3.png"),
        description: "map.event.lt03.desc",
        dialogues: [],
        autoAdvance: true,
        choices: [
            {
                id: "c1",
                text: "map.event.lt03.c1",
                nextDialogues: [
                    {
                        speaker: "map.speaker.amiya",
                        expression: "normal",
                        text: "map.event.lt03.c1d",
                    },
                ],
            },
        ],
        unlockGalleryId: "gal-lt-01",
    },

    "evt-lt-04": {
        id: "evt-lt-04",
        type: "event",
        image: require("@/assets/imgs/gallery/CG/cg-leithania-4.png"),
        description: "map.event.lt04.desc",
        dialogues: [],
        choices: [
            {
                id: "c1",
                text: "map.event.lt04.c1",
                resultText: "map.event.lt04.c1r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.lessing",
                        expression: "normal",
                        text: "map.event.lt04.cd",
                    },
                ],
            },
            {
                id: "c2",
                text: "map.event.lt04.c2",
                resultText: "map.event.lt04.c2r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.lessing",
                        expression: "normal",
                        text: "map.event.lt04.cd",
                    },
                ],
            },
        ],
        unlockGalleryId: "gal-lt-02",
    },

    "evt-lt-05": {
        id: "evt-lt-05",
        type: "event",
        image: require("@/assets/imgs/gallery/CG/cg-leithania-5.png"),
        description: "map.event.lt05.desc",
        dialogues: [],
        choices: [
            {
                id: "c1",
                text: "map.event.lt05.c1",
                resultText: "map.event.lt05.c1r",
                nextDialogues: [
                    {
                        speaker: "map.speaker.savage",
                        expression: "normal",
                        text: "map.event.lt05.c1d",
                    },
                ],
            },
        ],
        unlockGalleryId: "gal-lt-03",
    },
}
